import { useEffect, useState } from "react";
import { DataResult, State, toDataSourceRequestString } from "@progress/kendo-data-query";
import {
    Grid,
    GridColumn,
    GridDataStateChangeEvent,
} from "@progress/kendo-react-grid";
import { ColumnMenuDefaultFilter } from "../Shared/Components/ColumnMenuFilter";
import { useNavigate } from "react-router-dom";
import CountryService from "../Shared/Services/CountryService";

export const CountryList = () => {
    let initialState = { dataState: { skip: 0, take: 5 }, result: { data: [], total: 0 } };
    const [result, setResult] = useState<DataResult>(initialState.result);
    const [dataState, setDataState] = useState<State>(initialState.dataState);

    useEffect(() => {
        fetchData(dataState);
    }, []);

    const fetchData = (state: State) => {
        const queryStr = `${toDataSourceRequestString(state)}`; // Serialize the state
        CountryService.getAll(queryStr)
            .then((response) => {
                setResult({ data: response.data.data, total: response.data.total });
                setDataState(state);
            });
    }

    const dataStateChange = (event: GridDataStateChangeEvent) => {
        setDataState(event.dataState);
        fetchData(event.dataState);
    };

    const navigate = useNavigate();

    const renderActionCell = (props: any) => {
        return (
            <td>
                <a className="btn btn-primary btn-sm" onClick={() => navigate(`/editcountry/${props.dataItem.id}`)}>
                    <span className="k-icon k-i-edit k-icon-color"></span>
                </a> &nbsp;
                <a className="btn btn-primary btn-sm" onClick={() => navigate(`/viewcountry/${props.dataItem.id}`)}>
                    <span className="k-icon k-i-information k-icon-color"></span>
                </a>
            </td>
        );
    };

    return (
        <div className="card card-default">
            <div className="card-header">
                <h4>Countries
                    <button
                        title="Add new"
                        className="btn btn-primary pull-right"
                        onClick={() => navigate('/addcountry')}>
                        New Country
                    </button>
                </h4>
            </div>
            <div className="card-body card-body-custom">
            <Grid
                sortable={true}
                pageable={{
                    buttonCount: 4,
                    pageSizes: [5, 10, 15, 20],
                }}
                {...dataState}
                data={result}
                onDataStateChange={dataStateChange}>
                <GridColumn field="name" title="Name" columnMenu={ColumnMenuDefaultFilter} width="990px" />
                <GridColumn title="Action" cell={renderActionCell} width="250px" />
            </Grid>
            </div>
        </div>
    )
}